import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend"; // Enables loading translations from files
import LanguageDetector from "i18next-browser-languagedetector"; // Detects user language
import { APP_VERSION } from "../version";

i18n
  .use(HttpApi) // Load translations from JSON files
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ["en", "ar"], // Available languages
    fallbackLng: "en", // Default language if translation is missing
    debug: true, // Enable debugging
    interpolation: {
      escapeValue: false, // Not needed for React
    },
    backend: {
        // Cache-bust the locale files by app version. These static JSON files
        // aren't content-hashed like the JS bundle, so browsers cache them and
        // would keep serving a stale copy (missing newly-added keys, which then
        // render as the raw key name). Bumping APP_VERSION forces a fresh fetch.
        loadPath: `/locales/{{lng}}/messages.json?v=${APP_VERSION}`,
    },
    react: {
      useSuspense: false, // Disable Suspense to prevent UI blocking
    },
  });

export default i18n;
